import { createSlice } from '@reduxjs/toolkit';

type ITenantState = {
  currentTenantPid: string | null;
  tenantHasOrganizations: boolean | null;
};

const initialState: ITenantState = {
  currentTenantPid: null,
  tenantHasOrganizations: null,
};

const slice = createSlice({
  name: 'tenants',
  initialState,
  reducers: {
    saveCurrent(state: ITenantState, action: { payload: string }) {
      return {
        ...state,
        currentTenantPid: action.payload,
      };
    },
    setTenantHasOrganizations(state: ITenantState, action: { payload: boolean }) {
      return {
        ...state,
        tenantHasOrganizations: action.payload,
      };
    },
    clearTenantHasOrganizations(state: ITenantState) {
      return {
        ...state,
        tenantHasOrganizations: null,
      };
    },
  },
});

const { reducer } = slice;
const { saveCurrent, setTenantHasOrganizations, clearTenantHasOrganizations } = slice.actions;

if (!reducer) {
  throw new Error('No reducer found for tenant');
}

// eslint-disable-next-line import/no-unused-modules
export { reducer, slice, saveCurrent, setTenantHasOrganizations, clearTenantHasOrganizations };
